import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperType } from "swiper";
import styles from "./MobileStrip.module.scss";
import { TimelineEvent } from "../../model/data";

interface MobileStripProps {
  events: TimelineEvent[];
  currentSlideIndex?: number;
  onSlideChange: (index: number) => void;
  resetKey?: number;
  isAnimating?: boolean;
}

export const MobileStrip: React.FC<MobileStripProps> = ({
  events,
  currentSlideIndex = 0,
  onSlideChange,
  resetKey,
  isAnimating = false,
}) => {
  const swiperRef = useRef<SwiperType | null>(null);

  useEffect(() => {
    if (!swiperRef.current || resetKey === undefined) return;
    swiperRef.current.slideTo(0, 0);
    swiperRef.current.update();
  }, [resetKey, events.length]);

  const handleSlideChange = (swiper: SwiperType) => {
    onSlideChange(swiper.activeIndex);
  };

  return (
    <div className={`${styles.mStrip} ${isAnimating ? styles.isAnimating : ""}`}>
      <Swiper
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        onSlideChange={handleSlideChange}
        slidesPerView={1.2}
        spaceBetween={20}
        className={styles.swiper}
      >
        {events.map((event, index) => (
          <SwiperSlide key={index} className={styles.swiperSlide}>
            <div className={styles.mCard}>
              <div className={styles.mYear}>{event.year}</div>
              <div className={styles.mText}>{event.text}</div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

